// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".slot-data .el-dialog__body {\n  padding: 15px;\n}\n.slot-data .el-table .alert-row {\n  background: #ffaec8;\n}\n.slot-data .el-table--enable-row-hover .el-table__body tr.alert-row:hover > td {\n  background: #fa95b5;\n}\n.position-data--edit .el-dialog__body {\n  padding-top: 6px !important;\n  padding-bottom: 0 !important;\n}", ""]);
// Exports
module.exports = exports;
